'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _connectRoutes = require('../connectRoutes');

exports.default = function (dispatch, getState, route) {
  if (typeof window !== 'undefined') {
    var thunk = route.thunk;

    if (typeof thunk === 'function') {
      var _getState$location = getState().location,
          kind = _getState$location.kind,
          hasSSR = _getState$location.hasSSR;

      // call thunks always if it's not initial load of the app or only if it's load
      // without SSR setup yet, so app state is setup on client when prototyping,
      // such as with with webpack-dev-server before server infrastructure is built

      if (kind !== 'load' || kind === 'load' && !hasSSR) {
        var prom = thunk(dispatch, getState);

        if (prom && typeof prom.next === 'function') {
          prom.next(_connectRoutes.updateScroll);
        }
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-first-router/dist/pure-utils/attemptCallRouteThunk.js
// module id = 1084
// module chunks = 2